// @flow
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Prompt } from 'react-router-dom';

import StyledForm from '../shared/StyledForm';
import Scrollable from '../shared/Scrollable';

import Button from '../shared/Button';
import Select from '../shared/forms/Select';
import TextArea from '../shared/forms/TextArea';
import TextInput from '../shared/forms/TextInput';

export const validate = (values: Object) => {
    const errors = {};

    if (
        !Array.isArray(values.propertyTypeIds) ||
        values.propertyTypeIds.length < 1
    ) {
        errors.propertyTypeIds = 'Property type is required';
    }

    if (!values.status || values.status.length < 1) {
        errors.status = 'Status is required';
    }

    return errors;
};

let PropertyDescriptionForm = props => {
    const {
        handleSubmit,
        dirty,
        propertyTypeOptions,
        propertyStatusOptions,
        standardText,
        submitting,
    } = props;

    return (
        <StyledForm onSubmit={handleSubmit}>
            <Prompt
                when={dirty && !submitting}
                message="You have made changes that will be lost if you proceed. Are you sure you want to continue?"
            />

            <Scrollable additionalClassName="scroll-area">
                <div className="flex">
                    <div className="col">
                        <Field
                            name="propertyTypeIds"
                            label="Property Types"
                            multiple
                            component={Select}
                            size={propertyTypeOptions.length}
                            disabled={submitting}
                        >
                            {propertyTypeOptions.map(option =>
                                <option key={option.id} value={option.id}>
                                    {option.label}
                                </option>
                            )}
                        </Field>

                        <Field
                            name="availableFrom"
                            label="Available From"
                            component={TextInput}
                            disabled={submitting}
                        />

                        <Field
                            name="status"
                            label="Status"
                            component={Select}
                            disabled={submitting}
                        >
                            <option value="">Please select...</option>
                            {propertyStatusOptions.map(option =>
                                <option key={option.id} value={option.id}>
                                    {option.label}
                                </option>
                            )}
                        </Field>

                        <Field
                            name="description"
                            label="Description"
                            component={TextArea}
                            disabled={submitting}
                        />

                        <Field
                            name="locationDescription"
                            label="Location Description"
                            component={TextArea}
                            disabled={submitting}
                        />
                    </div>

                    <div className="col">
                        <Field
                            name="userPlanning"
                            label="User Planning"
                            component={TextArea}
                            disabled={submitting}
                        />

                        <Field
                            name="otherInformation"
                            label="Other Information"
                            component={TextArea}
                            disabled={submitting}
                        />

                        <Field
                            name="serviceCharge"
                            label="Service Charge"
                            component={TextArea}
                            disabled={submitting}
                        />

                        <Field
                            name="maintenance"
                            label="Maintenance"
                            component={TextArea}
                            disabled={submitting}
                            placeholder={
                                standardText.defaultTextItems.maintenance
                            }
                        />
                    </div>
                </div>
            </Scrollable>

            <div className="sticky-footer">
                <Button type="submit" disabled={submitting}>
                    {submitting ? 'Saving...' : 'Save & Continue'}
                </Button>
            </div>
        </StyledForm>
    );
};

PropertyDescriptionForm = reduxForm({
    form: 'propertyEditDescription',
    validate,
})(PropertyDescriptionForm);

export default PropertyDescriptionForm;



// WEBPACK FOOTER //
// ./src/components/PropertyForms/PropertyDescriptionForm.js